// @mui material components
import Grid from "@mui/material/Grid";
import RefreshIcon from "@mui/icons-material/Refresh";

// formik components
import { useFormikContext } from "formik";
import { useFormAnalyticsContext } from "contexts/contextFormAnalytics";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import FormField from "components/FormField";

function IncidenceAgeScalingForm({ formData }: any): JSX.Element {
  const { formField, values, errors, touched } = formData;
  const { incidenceScalingAge1, incidenceScalingAge2, incidenceScalingAge3, incidenceScalingAge4 } =
    formField;

  const { countryDefaults } = useFormAnalyticsContext();
  const { setValues } = useFormikContext<any>();

  const resetValues = () => {
    setValues((prev: any) => ({
      ...prev,
      incidenceScalingAge1: countryDefaults?.incidenceScalingAge1 ?? prev.incidenceScalingAge1,
      incidenceScalingAge2: countryDefaults?.incidenceScalingAge2 ?? prev.incidenceScalingAge2,
      incidenceScalingAge3: countryDefaults?.incidenceScalingAge3 ?? prev.incidenceScalingAge3,
      incidenceScalingAge4: countryDefaults?.incidenceScalingAge4 ?? prev.incidenceScalingAge4,
    }));
  };

  return (
    <MDBox>
      <Grid container alignItems="center" justifyContent={"space-between"}>
        <Grid item xs={10}>
          <MDTypography variant="h6">Incidence age-spec scaling: </MDTypography>
        </Grid>
        <Grid item xs={2}>
          <MDButton
            variant="gradient"
            color="dark"
            size="small"
            iconOnly
            onClick={() => resetValues()}
          >
            <RefreshIcon />
          </MDButton>
        </Grid>
        <Grid item xs={3}>
          <MDTypography variant="caption">{values.ageIntervalStart1}</MDTypography>
          <FormField
            disabled={true}
            type={incidenceScalingAge1.type}
            label={incidenceScalingAge1.label}
            name={incidenceScalingAge1.name}
            value={values.incidenceScalingAge1}
            placeholder={incidenceScalingAge1.placeholder}
          />
        </Grid>
        <Grid item xs={3}>
          <MDTypography variant="caption">{values.ageIntervalStart2}</MDTypography>
          <FormField
            type={incidenceScalingAge2.type}
            label={incidenceScalingAge2.label}
            name={incidenceScalingAge2.name}
            value={values.incidenceScalingAge2}
            placeholder={incidenceScalingAge2.placeholder}
            error={errors.incidenceScalingAge2 && touched.incidenceScalingAge2}
            precision={2}
          />
        </Grid>
        <Grid item xs={3}>
          <MDTypography variant="caption">{values.ageIntervalStart3}</MDTypography>
          <FormField
            type={incidenceScalingAge3.type}
            label={incidenceScalingAge3.label}
            name={incidenceScalingAge3.name}
            value={values.incidenceScalingAge3}
            placeholder={incidenceScalingAge3.placeholder}
            error={errors.incidenceScalingAge3 && touched.incidenceScalingAge3}
            precision={2}
          />
        </Grid>
        <Grid item xs={3}>
          <MDTypography variant="caption">{values.ageIntervalStart4}</MDTypography>
          <FormField
            type={incidenceScalingAge4.type}
            label={incidenceScalingAge4.label}
            name={incidenceScalingAge4.name}
            value={values.incidenceScalingAge4}
            placeholder={incidenceScalingAge4.placeholder}
            error={errors.incidenceScalingAge4 && touched.incidenceScalingAge4}
            precision={2}
          />
        </Grid>
        <Grid item xs={12}>
          <MDTypography
            variant="caption"
            color="error"
            fontWeight="regular"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {errors.incidenceScalingAge2 ||
              errors.incidenceScalingAge3 ||
              errors.incidenceScalingAge4}
          </MDTypography>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default IncidenceAgeScalingForm;
